import script from "./JournalView.vue?vue&type=script&setup=true&lang=ts"
export * from "./JournalView.vue?vue&type=script&setup=true&lang=ts"

import "./JournalView.vue?vue&type=style&index=0&id=12d7b59c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12d7b59c"]])

export default __exports__